// TEMPO DE ATENDIMENTO EM PORTUGUÊS (07/10/2026).
//
// Os relatórios usavam o `formatTime` do Chatwoot: "3 Min 20 Sec", "2 Hr",
// "1 Day" — em inglês, com Caixa Alta. Aqui: "3 min 20 s", "2 h 15 min",
// "1 dia 4 h". Duas unidades no máximo: a terceira é ruído num relatório.
export const duracaoLegivel = segundos => {
  const s = Math.max(0, Math.floor(Number(segundos) || 0));
  if (s < 60) return `${s} s`;
  if (s < 3600) {
    const min = Math.floor(s / 60);
    const resto = s % 60;
    return resto ? `${min} min ${resto} s` : `${min} min`;
  }
  if (s < 86400) {
    const h = Math.floor(s / 3600);
    const min = Math.floor((s % 3600) / 60);
    return min ? `${h} h ${min} min` : `${h} h`;
  }
  const dias = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const rotulo = dias === 1 ? 'dia' : 'dias';
  return h ? `${dias} ${rotulo} ${h} h` : `${dias} ${rotulo}`;
};
